const _excluded = ["id", "name", "children", "bottomArea"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Typography } from 'seagull';
import styles from "./PackageCard.module.scss";
export default function PackageCard(_ref) {
  let {
    id,
    name,
    children,
    bottomArea
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("li", {
    className: styles.packageCard,
    "data-testid": props['data-testid'],
    "data-bundleid": id
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.packageName,
    variant: "h5",
    "data-testid": props['data-testid'] + '-title'
  }, name), /*#__PURE__*/React.createElement("ul", {
    className: styles.sectionsList
  }, children), bottomArea);
}